import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ObservableInput } from 'ngx-observable-input';
import { Observable, of } from 'rxjs';
import { Multi } from '../../../../interfaces/multi.interface';

import { GraphQlAppendWheres } from '../../../../operators/graphql/append-wheres/graphql-append-wheres.operator';
import { GraphQlQueryExecutor } from '../../../../operators/graphql/query-executor/graphql-query-executor.operator';
import { GraphQlQueryResultToNgxMulti } from '../../../../operators/graphql/query-result-to-ngx-multi/graphql-query-result-to-ngx-multi.operator';
import { NgxMultiTimeline } from '../../../../operators/ngx/multi-timeline/multi-timeline.operator';
import { NgxMultiNameFunc } from '../../../../operators/ngx/multi-name-func/multi-name-func.operator';


import { EveInternal } from '../../../../operators/eve/interval/eve-interval.operator';

import { LineChartOptions } from '../../../../components/GraphQL/LineChart/linechart.component';
import * as d3 from "d3"
import { map } from 'rxjs/operators';
import { GraphQLComparision } from '../../../../enums/GraphQLComparision.enum';
import { GraphQLFilter, GraphQLGroupBy, GraphQlQuery, IGraphQlService } from '../../../../services/GraphQl/IGraphQL.service';
import { IVisibilityStateService } from '../../../../services/VisibilityState/IVisibilityState.service';


@Component({
  selector: 'total-missed-calls',
  templateUrl: './total-missed-calls.component.html',
  styleUrls: ['./total-missed-calls.component.css']
})
export class TotalMissedCallsComponent implements OnInit {
  @ViewChild('template') template: TemplateRef<any>;

  @ObservableInput()
  @Input("loading")
  loading$: TemplateRef<any>;

  @ObservableInput()
  @Input("noResults")
  noResults$: TemplateRef<any>;


  @ObservableInput()
  @Input("wheres")
  wheres$: Observable<GraphQLFilter[]>;

  @Output()
  select: EventEmitter<any> = new EventEmitter();

  totalMissedCallsResults: Observable<Multi[]>;

  totalMissedCallsQuery: Observable<GraphQlQuery>;
  totalMissedCallsByHourResults: Observable<Multi[]>;
  totalMissedCallsByDayResults: Observable<Multi[]>;

  totalMissedCallsOptions: LineChartOptions = {
    width: 2000,
    height: 800,
    xAxisLabel: "Hour/Day",
    yAxisLabel: "Total Missed Calls",
    xAxisTickFormatting: multiFormat,
    colourScheme: null
  }

  constructor(
    public graphQlService: IGraphQlService,
    public visibilityStateService: IVisibilityStateService
  ) {
  }

  ngOnInit(): void {
    
    

    this.totalMissedCallsQuery = of<GraphQlQuery>({
      dataset: "eveCdrsPage",
      selects: [
        {
          field: "count"
        },
        {
          field: "startTime",
        },
        {
          field: "eveCdrAnsweredType",
        },
      ],
      wheres: [
        { path: "eveCdrAnsweredType", comparison: GraphQLComparision.NOT_EQUAL, value: null },
        { path: "eveCdrAnsweredType", comparison: GraphQLComparision.NOT_EQUAL, value: 'EVE_USER' }
      ],
      groupBys: [
        { path: "eveCdrAnsweredType" }
      ],
      page: 0,
      pageSize: -1
    }).pipe(
      GraphQlAppendWheres(this.wheres$)
    )


    this.totalMissedCallsByHourResults = this.totalMissedCallsQuery.pipe(
      map(query => {
        return Object.assign({}, query, { groupBys: [{ path: "startTime", timeUnit: "HOURS" } as GraphQLGroupBy].concat(query.groupBys)})
      }),
      GraphQlQueryExecutor(of(this.graphQlService)),
      EveInternal(5000, this.visibilityStateService.VisibilityState()),
      GraphQlQueryResultToNgxMulti(),
      NgxMultiTimeline(
        this.wheres$.pipe(
          map(wheres => {
            const where = wheres.find(w => w.path == "startTime" && w.comparison == GraphQLComparision.GREATER_THAN_OR_EQUAL);
            return where.value
          })
        ),
        this.wheres$.pipe(
          map(wheres => {
            const where = wheres.find(w => w.path == "startTime" && w.comparison == GraphQLComparision.LESS_THAN_OR_EQUAL);
            return where.value
          })
        ), "HOURS"),
      //NgxMultiNameTemplate("${this.eveCdrAnsweredType}")
      NgxMultiNameFunc(multi => {

        if (multi.name == "DISCONNECTED") {
          return "Call Abandoned";
        }
        else if (multi.name == "EVE_USER") {
          return "EveUser";
        }
        else if (multi.name == "VOICEMAIL") {
          return "Voicemail";
        }

        return multi.name;
      })
    )

    this.totalMissedCallsByDayResults = this.totalMissedCallsQuery.pipe(
      map(query => {
        return Object.assign({}, query, { groupBys: [{ path: "startTime", timeUnit: "DAYS" } as GraphQLGroupBy].concat(query.groupBys) })
      }),
      GraphQlQueryExecutor(of(this.graphQlService)),
      EveInternal(5000, this.visibilityStateService.VisibilityState()),
      GraphQlQueryResultToNgxMulti(),
      NgxMultiTimeline(
        this.wheres$.pipe(
          map(wheres => {
            const where = wheres.find(w => w.path == "startTime" && w.comparison == GraphQLComparision.GREATER_THAN_OR_EQUAL);
            return where.value
          })
        ),
        this.wheres$.pipe(
          map(wheres => {
            const where = wheres.find(w => w.path == "startTime" && w.comparison == GraphQLComparision.LESS_THAN_OR_EQUAL);
            return where.value
          })
        ), "DAYS"),
      //NgxMultiNameTemplate("${this.eveCdrAnsweredType}")
      NgxMultiNameFunc(multi => {
         
        if (multi.name == "DISCONNECTED") {
          return "Call Abandoned";
        }
        else if (multi.name == "EVE_USER") {
          return "EveUser";
        }
        else if (multi.name == "VOICEMAIL") {
          return "Voicemail";
        }

        return multi.name;
      })
    )

  }


  public onSelect(data) {
    this.select.emit(data);
  }
}



var formatMillisecond = d3.timeFormat(".%L"),
  formatSecond = d3.timeFormat(":%S"),
  formatMinute = d3.timeFormat("%H:%M"),
  formatHour = d3.timeFormat("%H"),
  formatDay = d3.timeFormat("%a %d"),
  formatWeek = d3.timeFormat("%b %d"),
  formatMonth = d3.timeFormat("%B"),
  formatYear = d3.timeFormat("%Y");

function multiFormat(date) {
  return (d3.timeSecond(date) < date ? formatMillisecond
    : d3.timeMinute(date) < date ? formatSecond
      : d3.timeHour(date) < date ? formatMinute
        : d3.timeDay(date) < date ? formatHour
          : d3.timeMonth(date) < date ? (d3.timeWeek(date) < date ? formatDay : formatWeek)
            : d3.timeYear(date) < date ? formatMonth
              : formatYear)(date);
}
